import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnInit
} from '@angular/core';
import { FormControl } from '@angular/forms';

@Directive({
  selector: '[appCurrencyInput]',
  standalone: false
})
export class CurrencyInputDirective implements OnInit {
  constructor(private el: ElementRef) {}

  @Input('appCurrencyInput') formControl!: FormControl;
  @Input() maxValue?: number;

  DEFAULT_MAX_VALUE = 1_000_000_000;

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    if (!this.formControl) {
      return;
    }

    const numericValue = this.stripFormatting(
      (event.target as HTMLInputElement).value
    );

    const appliedMax =
      this.maxValue !== undefined ? this.maxValue : this.DEFAULT_MAX_VALUE;

    if (
      numericValue !== null &&
      appliedMax !== null &&
      numericValue > appliedMax
    ) {
      this.setInputValue(this.formatCurrency(this.formControl.value));
      return;
    }

    this.formControl.setValue(numericValue, { emitEvent: true });

    const formattedValue = this.formatCurrency(numericValue);
    this.setInputValue(formattedValue);
  }

  @HostListener('blur')
  onBlur() {
    if (!this.formControl || this.formControl.value === null) {
      return;
    }

    this.setInputValue(this.formatCurrency(this.formControl.value));
  }

  @HostListener('focus')
  onFocus() {
    if (!this.formControl || this.formControl.value === null) {
      return;
    }

    this.setInputValue(this.formControl.value.toString());
  }

  stripFormatting(value: string): number | null {
    const numericValue = value.replace(/[^0-9]/g, '');
    return numericValue ? parseInt(numericValue, 10) : null;
  }

  formatCurrency(value: number | null): string {
    return value !== null ? value.toLocaleString('en-US') : '';
  }

  setInputValue(value: string): void {
    const inputElement = this.el.nativeElement as HTMLInputElement;
    if (inputElement) {
      inputElement.value = value;
    }
  }

  ngOnInit() {
    if (this.formControl) {
      const initialValue = this.formatCurrency(this.formControl.value);
      this.setInputValue(initialValue);
    }
  }
}
